import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: true,
	feature: HubFeature.Core,
	portal: 'SP',
};

export type CPTableDataPaginationLoc =
	| 'CPTableDataPaginationLabel'
	| 'CPTableDataPaginationLabelOptions'
	| 'CPTableDataPaginationLabelFirstPage'
	| 'CPTableDataPaginationLabelLastPage'
	| 'CPTableDataPaginationLabelNextPage'
	| 'CPTableDataPaginationLabelPreviousPage';

export const cpTableDataPaginationLocs: LocDefs<CPTableDataPaginationLoc> = {
	CPTableDataPaginationLabel: {
		defaultValue: 'Pagination',
		description: 'Assistive label for the data pagination controls',
		displayPath: 'Data View|Pagination Label',
		displayType: 'Label',
		...sharedProps,
	},
	CPTableDataPaginationLabelOptions: {
		defaultValue: 'Items per page:',
		description: 'Label for the pagination options menu.',
		displayPath: 'Data View|Pagination Options',
		displayType: 'Label',
		legacyName: 'Core/System.Table.Label.PaginationOptions',
		...sharedProps,
	},
	CPTableDataPaginationLabelFirstPage: {
		defaultValue: 'First Page',
		description: 'Label for the pagination first page button.',
		displayPath: 'Data View|Pagination First Page',
		displayType: 'Label',
		legacyName: 'Core/System.Table.Button.PaginationFirstPage',
		...sharedProps,
	},
	CPTableDataPaginationLabelLastPage: {
		defaultValue: 'Last Page',
		description: 'Label for the pagination last page button.',
		displayPath: 'Data View|Pagination Last Page',
		displayType: 'Label',
		legacyName: 'Core/System.Table.Button.PaginationLastPage',
		...sharedProps,
	},
	CPTableDataPaginationLabelNextPage: {
		defaultValue: 'Next Page',
		description: 'Label for the pagination next page button.',
		displayPath: 'Data View|Pagination Next Page',
		displayType: 'Label',
		legacyName: 'Core/System.Table.Button.PaginationNextPage',
		...sharedProps,
	},
	CPTableDataPaginationLabelPreviousPage: {
		defaultValue: 'Previous Page',
		description: 'Label for the pagination previous page button.',
		displayPath: 'Data View|Pagination Previous Page',
		displayType: 'Label',
		legacyName: 'Core/System.Table.Button.PaginationPreviousPage',
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<CPTableDataPaginationLoc>(cpTableDataPaginationLocs);
export type CPTableDataPaginationLocType = LocMap<CPTableDataPaginationLoc>;
